import React  from 'react'
import DropDown from '../dropdown';
import { PriceLists } from '../../../api/services/next'

const StatisticSourcesDropDown = ({...rest}) => {
    return <DropDown api={PriceLists.GetStatisticSources} search textField="Name" valueField="Id" {...rest}/>
}

export default StatisticSourcesDropDown;

